import React from "react";

const Socials = ({
  socialsFormData,
  setSocialsFormData,
  socialsFormErrors,
  setSocialsFormErrors,
}) => {
  // Handle input changes
  const handleChange = (field, value) => {
    setSocialsFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user types
    if (socialsFormErrors[field]) {
      setSocialsFormErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  return (
    <>
      <div className="parentsteps">
        <section className="foursteps lateststeps">
          <div className="newinner ">
            {/* Project Website - Required */}
            <h2>Project Website <span className="redspan">*</span></h2>
            <input
              type="text"
              name="projectWebsite"
              value={socialsFormData.projectWebsite}
              onChange={(e) => handleChange("projectWebsite", e.target.value)}
              placeholder="Enter Project Website"
              className={socialsFormErrors.projectWebsite ? "error" : ""}
            />
            {socialsFormErrors.projectWebsite && (
              <span className="error-text">
                {socialsFormErrors.projectWebsite}
              </span>
            )}

            {/* Twitter - Optional */}
            <h2>
              Twitter <span>(Optional)</span>
            </h2>
            <input
              type="text"
              name="projectTwitter"
              value={socialsFormData.projectTwitter}
              onChange={(e) => handleChange("projectTwitter", e.target.value)}
              placeholder="Enter twitter handle"
              className={socialsFormErrors.projectTwitter ? "error" : ""}
            />
            {socialsFormErrors.projectTwitter && (
              <span className="error-text">
                {socialsFormErrors.projectTwitter}
              </span>
            )}

            {/* Telegram - Optional */}
            <h2>
              Telegram <span>(Optional)</span>
            </h2>
            <input
              type="text"
              name="projectTelegram"
              value={socialsFormData.projectTelegram}
              onChange={(e) => handleChange("projectTelegram", e.target.value)}
              placeholder="Enter telegram link"
              className={socialsFormErrors.projectTelegram ? "error" : ""}
            />
            {socialsFormErrors.projectTelegram && (
              <span className="error-text">
                {socialsFormErrors.projectTelegram}
              </span>
            )}

            {/* Medium - Optional */}
            <h2>
              Medium <span>(Optional)</span>
            </h2>
            <input
              type="text"
              name="projectMedium"
              value={socialsFormData.projectMedium}
              onChange={(e) => handleChange("projectMedium", e.target.value)}
              placeholder="Enter medium link"
              className={socialsFormErrors.projectMedium ? "error" : ""}
            />
            {socialsFormErrors.projectMedium && (
              <span className="error-text">
                {socialsFormErrors.projectMedium}
              </span>
            )}

            {/* Youtube - Optional */}
            <h2>
              Youtube <span>(Optional)</span>
            </h2>
            <input
              type="text"
              name="projectYoutube"
              value={socialsFormData.projectYoutube}
              onChange={(e) => handleChange("projectYoutube", e.target.value)}
              placeholder="Enter youtube link"
              className={socialsFormErrors.projectYoutube ? "error" : ""}
            />
            {socialsFormErrors.projectYoutube && (
              <span className="error-text">
                {socialsFormErrors.projectYoutube}
              </span>
            )}

            {/* Discord - Optional */}
            <h2>
              Discord <span>(Optional)</span>
            </h2>
            <input
              type="text"
              name="projectDiscord"
              value={socialsFormData.projectDiscord}
              onChange={(e) => handleChange("projectDiscord", e.target.value)}
              placeholder="Enter discord link"
              className={socialsFormErrors.projectDiscord ? "error" : ""}
            />
            {socialsFormErrors.projectDiscord && (
              <span className="error-text">
                {socialsFormErrors.projectDiscord}
              </span>
            )}

            {/* LinkedIn - Optional */}
            <h2>
              LinkedIn <span>(Optional)</span>
            </h2>
            <input
              type="text"
              name="projectLinkedIn"
              value={socialsFormData.projectLinkedIn}
              onChange={(e) => handleChange("projectLinkedIn", e.target.value)}
              placeholder="Enter LinkedIn link"
              className={socialsFormErrors.projectLinkedIn ? "error" : ""}
            />
            {socialsFormErrors.projectLinkedIn && (
              <span className="error-text">
                {socialsFormErrors.projectLinkedIn}
              </span>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default Socials;
